import { useEffect, useRef, useCallback } from 'react';
import { useContextMenuContext } from './ContextMenuProvider';
import { HookArgs } from './types';

const useContextMenu = <Element extends HTMLElement>({
  actions,
  onOpen,
}: HookArgs) => {
  const ref = useRef<Element | null>(null);
  const { open } = useContextMenuContext();

  const openContextMenu = useCallback(
    async (event: any) => {
      event.preventDefault();
      event.stopPropagation();
      onOpen?.();

      open({
        x: event.clientX,
        y: event.clientY,
        actions: await actions,
      });

      return false;
    },
    [actions],
  );

  useEffect(() => {
    if (ref.current) {
      ref.current.addEventListener('contextmenu', openContextMenu);
    }

    return () => {
      if (ref.current) {
        ref.current.removeEventListener('contextmenu', openContextMenu);
      }
    };
  }, [openContextMenu]);

  return {
    ref,
  };
};

export default useContextMenu;
